import { CapabilitiesPageData } from "@/types";
import { ClientLogo } from "@/types/home";

const civilianLogos: ClientLogo[] = [
  {
    id: 1,
    src: "/images/capabilities/civilian/HCL Foundation.png",
    alt: "HCL Foundation",
    name: "HCL Foundation",
  },
  {
    id: 2,
    src: "/images/capabilities/civilian/Maharashtra Tourism Development Corporation.jpeg",
    alt: "Maharashtra Tourism Development Corporation",
    name: "Maharashtra Tourism Development Corporation",
  },
  {
    id: 3,
    src: "/images/capabilities/civilian/Manipal Academy of Higher Education.png",
    alt: "Manipal Academy of Higher Education",
    name: "Manipal Academy of Higher Education",
  },
  {
    id: 4,
    src: "/images/capabilities/civilian/National Institute of Oceanography.png",
    alt: "National Institute of Oceanography",
    name: "National Institute of Oceanography",
  },
  {
    id: 5,
    src: "/images/capabilities/civilian/Omcar foundation.png",
    alt: "Omcar Foundation",
    name: "Omcar Foundation",
  },
  {
    id: 6,
    src: "/images/capabilities/civilian/Wildlife Conservation Society - India.jpeg",
    alt: "Wildlife Conservation Society - India",
    name: "Wildlife Conservation Society - India",
  },
  {
    id: 7,
    src: "/images/capabilities/civilian/Wildlife Institute Of India.jpeg",
    alt: "Wildlife Institute of India",
    name: "Wildlife Institute of India",
  },
];

const combatLogos: ClientLogo[] = [
  {
    id: 1,
    src: "/images/capabilities/combat/1 Para SF.png",
    alt: "1 Para SF",
    name: "1 Para SF",
  },
  {
    id: 2,
    src: "/images/capabilities/combat/2 Para SF.png",
    alt: "2 Para SF",
    name: "2 Para SF",
  },
  {
    id: 3,
    src: "/images/capabilities/combat/10 Para SF.png",
    alt: "10 Para SF",
    name: "10 Para SF",
  },
  {
    id: 4,
    src: "/images/capabilities/combat/11 Para SF.png",
    alt: "11 Para SF",
    name: "11 Para SF",
  },
  {
    id: 5,
    src: "/images/capabilities/combat/13 Para SF.png",
    alt: "13 Para SF",
    name: "13 Para SF",
  },
  {
    id: 6,
    src: "/images/capabilities/combat/21 Para SF.png",
    alt: "21 Para SF",
    name: "21 Para SF",
  },
  {
    id: 7,
    src: "/images/capabilities/combat/411 Para Fd Coy.png",
    alt: "411 Para Fd Coy",
    name: "411 Para Fd Coy",
  },
  // {
  //   id: 8,
  //   src: "/images/capabilities/combat/Army Cantonment Nahan.png",
  //   alt: "Army Cantonment Nahan",
  //   name: "Army Cantonment Nahan",
  // },
  {
    id: 9,
    src: "/images/capabilities/combat/Eastern Command.png",
    alt: "Eastern Command",
    name: "Eastern Command",
  },
  {
    id: 10,
    src: "/images/capabilities/combat/HQ 50 (I) Para Bde Agra.png",
    alt: "HQ 50 (I) Para Bde Agra",
    name: "HQ 50 (I) Para Bde Agra",
  },
  {
    id: 11,
    src: "/images/capabilities/combat/INS Abhimanyu.png",
    alt: "INS Abhimanyu",
    name: "INS Abhimanyu",
  },
  {
    id: 12,
    src: "/images/capabilities/combat/Parachute Regiment.png",
    alt: "Parachute Regiment",
    name: "Parachute Regiment",
  },
  {
    id: 13,
    src: "/images/capabilities/combat/Special Forces Training School.png",
    alt: "Special Forces Training School",
    name: "Special Forces Training School",
  },
];

const navyLogos: ClientLogo[] = [
  {
    id: 1,
    src: "/images/capabilities/navy/Cochin_Shipyard_SVG_Logo.svg",
    alt: "Cochin Shipyard",
    name: "Cochin Shipyard",
  },
  {
    id: 2,
    src: "/images/capabilities/navy/Command Clearance Diving Team - Mumbai.png",
    alt: "Command Clearance Diving Team - Mumbai",
    name: "Command Clearance Diving Team - Mumbai",
  },
  {
    id: 3,
    src: "/images/capabilities/navy/Goa Shipyard Ltd..jpeg",
    alt: "Goa Shipyard Ltd.",
    name: "Goa Shipyard Ltd.",
  },
  {
    id: 4,
    src: "/images/capabilities/navy/INS Karna.png",
    alt: "INS Karna",
    name: "INS Karna",
  },
  {
    id: 5,
    src: "/images/capabilities/navy/LnT Limited.png",
    alt: "Larsen & Toubro Limited",
    name: "Larsen & Toubro Limited",
  },
  {
    id: 6,
    src: "/images/capabilities/navy/MARCOS.png",
    alt: "MARCOS",
    name: "MARCOS",
  },
  {
    id: 7,
    src: "/images/capabilities/navy/Material Organisation.png",
    alt: "Material Organisation, ANI",
    name: "Material Organisation, ANI",
  },
  {
    id: 8,
    src: "/images/capabilities/navy/Navy Diving School.png",
    alt: "Navy Diving School",
    name: "Navy Diving School",
  },
];

const publicSafetyLogos: ClientLogo[] = [
  {
    id: 1,
    src: "/images/capabilities/public-safety/154 INFANTRY BATTALION TERRITORIAL ARMY BIHAR.png",
    alt: "154 Infantry Battalion Territorial Army Bihar",
    name: "154 Infantry Battalion Territorial Army Bihar",
  },
  {
    id: 2,
    src: "/images/capabilities/public-safety/17 FBSU Indian Air Force.png",
    alt: "17 FBSU Indian Air Force",
    name: "17 FBSU Indian Air Force",
  },
  {
    id: 3,
    src: "/images/capabilities/public-safety/172.png",
    alt: "172 Infantry Battalion (Territorial Army), Port Blair",
    name: "172 Infantry Battalion (Territorial Army), Port Blair",
  },
  {
    id: 4,
    src: "/images/capabilities/public-safety/Andaman Nicobar Fire Emergency Services.png",
    alt: "Andaman & Nicobar Fire & Emergency Services",
    name: "Andaman & Nicobar Fire & Emergency Services",
  },
  {
    id: 5,
    src: "/images/capabilities/public-safety/Andaman Nicobar Police Marine Force.png",
    alt: "Andaman & Nicobar Police Marine Force",
    name: "Andaman & Nicobar Police Marine Force",
  },
  {
    id: 6,
    src: "/images/capabilities/public-safety/Army Adventure Nodal Centre.png",
    alt: "Army Adventure Nodal Centre",
    name: "Army Adventure Nodal Centre",
  },
  {
    id: 7,
    src: "/images/capabilities/public-safety/Department of Environment.png",
    alt: "Department of Environment & Forests, ANI",
    name: "Department of Environment & Forests, ANI",
  },
  {
    id: 8,
    src: "/images/capabilities/public-safety/HCL Foundation.png",
    alt: "HCL Foundation",
    name: "HCL Foundation",
  },
  {
    id: 9,
    src: "/images/capabilities/public-safety/India Reserve Battalion.png",
    alt: "India Reserve Battalion",
    name: "India Reserve Battalion",
  },
  {
    id: 10,
    src: "/images/capabilities/public-safety/NDRF.png",
    alt: "NDRF",
    name: "NDRF",
  },
  {
    id: 11,
    src: "/images/capabilities/public-safety/Allied Sports.png",
    alt: "Nat. Inst. of Mountaineering & Allied Sports",
    name: "Nat. Inst. of Mountaineering & Allied Sports",
  },
  {
    id: 12,
    src: "/images/capabilities/public-safety/The Habitats Trust.jpg",
    alt: "The Habitats Trust",
    name: "The Habitats Trust",
  },
  {
    id: 13,
    src: "/images/capabilities/public-safety/Uttar Pradesh Fire Emergency Services.png",
    alt: "Uttar Pradesh Fire & Emergency Services",
    name: "Uttar Pradesh Fire & Emergency Services",
  },
];

export const capabilitiesPageData: CapabilitiesPageData = {
  header: {
    badge: " Domains of Deployment",
    subtitle:
      "When the goal is in-water readiness before the mission demands it, dependable performance is the only standard. That’s why our journey with you extends way beyond the supply – from demonstrations and training, to aligning quality to operational requirements.",
  },
  tabs: [
    {
      id: "combat-special-ops",
      tabNumber: 1,
      totalTabs: 4,
      tabLabel: "Combat & Special Ops",
      title: "Combat & Special Ops Diving",
      subtitle:
        "Tactical underwater combat capabilities, stealth diving operations, and high-stakes mission readiness.",
      description:
        "From Dry Diving Suits to Open Circuit Scuba sets, from basic accessories to cutting-edge technology – We supply, provide demonstration and conduct training for equipment, that is built to support covert entries and exits, precise movement and the adaptability every operation demands.",
      image: {
        src: "/images/home/domain-of-deployment/ops-diving.jpeg",
        alt: "Combat & Special Ops Diving",
      },
      clientsServedLabel: "Esteemed Partners",
      logos: combatLogos,
    },
    {
      id: "navy-coast-guard",
      tabNumber: 2,
      totalTabs: 4,
      tabLabel: "Navy & Coast Guard",
      title: "Navy & Coast Guard",
      subtitle:
        "Maritime defense, deep-sea clearance diving, vessel inspection, and salvage operations.",
      description:
        "With experience in equipping Aircraft Carriers and Patrol Boats with state-of-the-art gear – from Navigation & Locator Systems to Kayaks and RIBs – we offer 360° support – supply, service and training – for Navy & Coast Guard Divers to navigate uncharted and unsparing waters with ease.",
      image: {
        src: "/images/home/domain-of-deployment/Coast-Guard.jpeg",
        alt: "Navy & Coast Guard",
      },
      clientsServedLabel: "Esteemed Partners",
      logos: navyLogos,
    },
    {
      id: "public-safety-hadr",
      tabNumber: 3,
      totalTabs: 4,
      tabLabel: "Public Safety & HADR",
      title: "Public Safety & HADR",
      subtitle:
        "Swift response humanitarian assistance, disaster relief, and specialized search & recovery.",
      description:
        "From supplying Closed Circuit Rebreathers to Wireless Communication Systems to providing best-in-class service & training – we’ve deployed over 375 HADR kits for our braveheart divers to aid them in saving lives.",
      image: {
        src: "/images/home/domain-of-deployment/Public_Safety.jpeg",
        alt: "Public Safety & HADR",
      },
      clientsServedLabel: "Esteemed Partners",
      logos: publicSafetyLogos,
    },
    {
      id: "civilian-training",
      tabNumber: 4,
      totalTabs: 4,
      tabLabel: "Civilian Training",
      title: "Civilian Training",
      subtitle:
        "Building elite recreational, technical, and professional diving competencies with globally certified curricula.",
      description:
        "Our civilian training facility – DIVEIndia, is an SSI Diamond Instructor Training Center with 75+ years of cumulative experience – 200+ dive pros trained, 18000+ students certified & 250000+ dives conducted. We operate across Havelock & Neil Islands where we offer Diving & Training Programs from Beginner to Professional, Extended Range to Freediving, and beyond!",
      image: {
        src: "/images/home/domain-of-deployment/civilian_training.png",
        alt: "Civilian Training",
      },
      clientsServedLabel: "Esteemed Partners",
      logos: civilianLogos,
    },
  ],
  equipmentTitle: "Equipment Catalogue",
};
